import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { formatDateWithTime, withRouter } from "../../shared/utility";
import { MixedCartonHistoryViewModel } from "../../viewmodels/traceability/MixedCartonHistoryViewModel";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useRef } from "react";
import MixedCartonHistoryTable from "./mixedCartonHistory/MixedCartonHistoryTable";
import MixedCartonSourceItemsTable from "./mixedCartonHistory/MixedCartonSourceItemsTable";
import EmptyModal from "../../components/modals/EmptyModal";
import { Skeleton } from "primereact/skeleton";

function MixedCartonHistoryScreen(props) {
  const { logout } = props;
  const {
    mixedCarton,
    getMixedCartonHistory,
    loading,
    emptyModal,
    setEmptyModelOpen,
  } = MixedCartonHistoryViewModel(logout);

  const searchRef = useRef();

  return (
    <div>
      <div className="mt-2 lg:px-8 space-y-4">
        <div className="sm:flex sm:items-center px-4 py-5 card-custom">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold leading-6 text-gray-900">
              Mixed Carton History
            </h1>
            <div className="mt-5 flex rounded-md">
              <div className="relative flex items-stretch flex-grow focus-within:z-10">
                <input
                  type="search"
                  name="searchMixedCarton"
                  id="searchMixedCarton"
                  className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                  placeholder="Search by mixed carton barcode"
                  ref={searchRef}
                  onKeyDown={(e) => {
                    if (e.key === "Enter")
                      getMixedCartonHistory(searchRef.current.value);
                  }}
                />
              </div>
              <button
                type="button"
                className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                onClick={() =>
                  getMixedCartonHistory(searchRef.current.value)
                }
              >
                <MagnifyingGlassIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </button>
            </div>
          </div>
        </div>
        {loading ? (
          <div className="space-y-2">
            <Skeleton width="100%" height="8rem" borderRadius="16px"></Skeleton>
            <Skeleton width="100%" height="8rem" borderRadius="16px"></Skeleton>
          </div>
        ) : mixedCarton.barcode ? (
          <div>
            <div>
              <div className="px-4 py-5 card-custom">
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <p>Barcode: {mixedCarton.barcode}</p>
                    <p>Order Invoice #: {mixedCarton.order.invoice_number}</p>
                    <p>Customer: {mixedCarton.order.customer.name}</p>
                    <p>Created By: {mixedCarton.shipped_by_name}</p>
                    <p className="font-bold text-cyan-700">
                      Status: {mixedCarton.is_returned === 1 ? "Returned" : "Shipped"}
                    </p>
                    <p>
                      Created Date: {formatDateWithTime(mixedCarton.created_at)}
                    </p>
                  </div>
                  <div className="space-y-2">
                    <p>Subtotal: ${mixedCarton.subtotal_amount}</p>
                    <p>Tax: ${mixedCarton.tax_amount}</p>
                    <p>Total Cost: ${mixedCarton.total_cost}</p>
                  </div>
                </div>
              </div>
            </div>
            <MixedCartonHistoryTable historyData={mixedCarton.barcode_histories} />
              <div className="mt-4">
                <h2 className="text-base font-semibold leading-6 text-gray-900 mb-4 px-4">
                  Items in Mixed Carton
                </h2>
                <MixedCartonSourceItemsTable sourceItemsData={mixedCarton.source_items} />
              </div>
          </div>
        ) : null}
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
        size={emptyModal.size}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MixedCartonHistoryScreen)
);
